var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.03 28.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Projekte"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.66,22.31h-13.42c-2.96,0-5.37-2.41-5.37-5.37V5.37c0-2.96,2.41-5.37,5.37-5.37h13.42c2.96,0,5.37,2.41,5.37,5.37v11.56c0,2.96-2.41,5.37-5.37,5.37ZM11.24,1.6c-2.08,0-3.77,1.69-3.77,3.77v11.56c0,2.08,1.69,3.77,3.77,3.77h13.42c2.08,0,3.77-1.69,3.77-3.77V5.37c0-2.08-1.69-3.77-3.77-3.77h-13.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.5,23.49c-.33,1.75-1.86,3.07-3.7,3.07H5.37c-2.08,0-3.77-1.69-3.77-3.77v-11.56c0-1.81,1.28-3.32,2.99-3.69v-1.61c-2.59.39-4.59,2.6-4.59,5.29v11.56c0,2.96,2.41,5.37,5.37,5.37h13.42c2.72,0,4.95-2.04,5.3-4.67h-1.6Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/Project.4b84dd133baa9cc0a5db3de5c69b75ac.svg";
export { ForwardRef as ReactComponent };